import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationOriginIntegrationUpdateArgs, OriginIntegration } from "types/generated";

export type UpdateOriginIntegrationData = Pick<
  OriginIntegration,
  "vcsChecks" | "useGitCheckout" | "vcsCheckOptions"
>;

type UpdateOriginIntegrationQueryData = {
  originIntegrationUpdate: UpdateOriginIntegrationData;
};

export const UPDATE_ORIGIN_INTEGRATION: TypedDocumentNode<
  UpdateOriginIntegrationQueryData,
  MutationOriginIntegrationUpdateArgs
> = gql`
  mutation UpdateOriginIntegration(
    $vcsChecks: VCSCheck!
    $vcsCheckOptions: VCSCheckOptionsInput
  ) {
    originIntegrationUpdate(
      vcsChecks: $vcsChecks
      vcsCheckOptions: $vcsCheckOptions
    ) {
      vcsChecks
      vcsCheckOptions {
        individualFailuresOnly
        individualSkipUnchanged
      }
    }
  }
`;
